import React from "react";

class TermsnConditions extends React.Component {
  render() {
    return "";
  }
}

export default TermsnConditions;
